import axios from "axios";
import { dashboardTicketCreateApi, dashboardTicketEditApi } from "../constants/apis";
import { getUserToken } from "../helpers/local_storage_helpers";

const appendIfDefined = (formData, key, value) => {
    if (value === undefined) return;
    formData.append(key, value);
};

const createTicketFormData = (formValues, { onlyKeys } = {}) => {
    const formData = new FormData();
    const keys = onlyKeys || Object.keys(formValues || {});

    keys.forEach((key) => appendIfDefined(formData, key, formValues?.[key]));
    return formData;
};

export const createDashboardTicket = async (formValues, token) => {
    const formData = createTicketFormData(formValues);
    const response = await axios.post(dashboardTicketCreateApi, formData, {
        headers: {
            Authorization: `Token ${token || getUserToken()}`,
        },
    });
    return response;
};

export const updateDashboardTicket = async (ticketId, formValues, token) => {
    const changedKeys = Object.keys(formValues || {}).filter(
        (key) => formValues[key] !== undefined
    );
    const formData = createTicketFormData(formValues, { onlyKeys: changedKeys });

    const response = await axios.patch(`${dashboardTicketEditApi}${ticketId}/edit/`, formData, {
        headers: {
            Authorization: `Token ${token || getUserToken()}`,
        },
    });
    return response;
};
